import React from 'react';
import { type IRecommendationConfigContextShape } from '../../../types/recommendationTypes';

export const RecommendationConfigContext = React.createContext<IRecommendationConfigContextShape | null>(null);

export default RecommendationConfigContext;
